import { partial } from '../../../util/translation/translation';

const p = partial('validateErrors.participantFormErrors');
const validateParticipants = (values) => {
  const errors = {};

  if (!values.firstName) {
    errors.owner = p('userFieldCantBeEmpty');
  }

  if (!values.firstName) {
    errors.firstName = p('firstNameFieldCantBeEmpty');
  }

  if (!values.lastName) {
    errors.lastName = p('lastNameFieldCantBeEmpty');
  }

  if (!values.phoneNumber) {
    errors.phoneNumber = p('phoneFieldCantBeEmpty');
  }

  if (!values.email) {
    errors.email = p('emailFieldCantBeEmpty');
  }
  return errors;
};

export default validateParticipants;
